import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AuthenticationService } from '@next/core-lib/authentication';
import { PageToolbarComponent } from '@next/core-lib/components';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  imports: [PageToolbarComponent, MatButton, MatIcon, TranslatePipe],
})
export class UnauthorizedComponent {
  private readonly router = inject(Router);
  private readonly authentication = inject(AuthenticationService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  logout() {
    this.authentication.logout();
    this.router.navigate(['/']);
  }
}
